'use client';

import Link from 'next/link';
import { FavouritesCount } from '../ProductToolbar/FavouritesCount';

export type ProductDetailsTopBarProps = {
  /** Where the back link points, e.g. the SRP for this product type. */
  backHref: string;
  /** Visible link text, e.g. "View All Carpet". */
  backLabel: string;
  /** Screen-reader label; defaults to the visible text. */
  backAriaLabel?: string;
};

/** Back link on the left, favourites counter on the right. */
export const ProductDetailsTopBar = ({
  backHref,
  backLabel,
  backAriaLabel,
}: ProductDetailsTopBarProps) => (
  <>
    <Link
      className="ui-flex ui-items-center ui-gap-2 !ui-text-sm !ui-text-gray-500 hover:!ui-text-gray-600"
      href={backHref}
      aria-label={backAriaLabel ?? backLabel}
      prefetch={false}
    >
      <svg
        className="ui-w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        aria-hidden="true"
      >
        <path
          className="ui-fill-gray-500"
          d="M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"
        />
      </svg>
      {backLabel}
    </Link>
    <FavouritesCount />
  </>
);
